export const createJudgingProgrammeJudgesRequests = (client) => ({
    listJudgingProgrammeJudges: async (params) => {
        const { data, meta, links } = await client.api.get("judging_programme_judges", {
            params: params,
        });
        return { data, meta, links };
    },
});
//# sourceMappingURL=index.js.map